/*
 * @Author: huguantao1@jd.com
 * @Date: 2025-02-10 15:16:23
 * @LastEditors: huguantao1@jd.com
 * @LastEditTime: 2025-03-14 20:21:30
 * @FilePath: /intl-pc-jdi-website-ssr/src/components/product/flashSale.tsx
 * @Description: default
 */
'use client';

import { CN_PRODUCT } from '@/components/product/const';
import { useEffect, useState } from 'react';
// -------------- 图标 -------------------- //

import { dataExpTagConfig } from '@/components/product/const';
import { useTranslation } from '@/i18n/client';
import { EXPOSURE_RECORD } from '@/tracks/25217';
import { useParams } from 'next/navigation';

interface FlashSaleCountdownProps {
  saleTag: string;
}

interface FlashSaleProps extends FlashSaleCountdownProps {
  countdown: number;
  curTimeField?: number;
}

// duration 时间差 ms
const duration2HMS = (duration: number) => {
  duration = Math.max(~~duration, 0);
  const s = duration % 60;
  const m = ~~(duration / 60) % 60;
  const h = ~~(duration / 60 / 60);
  return { h, m, s };
};

export function FlashSaleWithoutCountdown({ saleTag }: FlashSaleCountdownProps) {
  const { sku: skuId } = useParams<{ sku: string }>();
  return (
    <div
      className={CN_PRODUCT('flash-sale')}
      exptag={'exp|' + EXPOSURE_RECORD.Productdetail_SinglePromotionFloor_Expo}
      data-exptag-config={dataExpTagConfig}
      data-exptag-json-param={JSON.stringify({
        mainskuid: skuId,
        activityName: 'flash-sale',
        activityId: 'flash-sale',
      })}
    >
      <span className='flag'>{saleTag}</span>
    </div>
  );
}

export default function FlashSale({ countdown, curTimeField, saleTag }: FlashSaleProps) {
  const start = curTimeField || new Date().getTime();
  const realCountDown = countdown + (start - new Date().getTime()) / 1000;
  const { sku: skuId } = useParams<{ sku: string }>();
  const { t } = useTranslation();
  const [hour, setHour] = useState(duration2HMS(realCountDown).h);
  const [minute, setMinute] = useState(duration2HMS(realCountDown).m);
  const [second, setSecond] = useState(duration2HMS(realCountDown).s);

  const refreshCountdown = () => {
    const { s, m, h } = duration2HMS(countdown + (start - new Date().getTime()) / 1000);
    setHour(h);
    setMinute(m);
    setSecond(s);
    if (s === 0 && m === 0 && h === 0) {
      return -1;
    } else {
      return 1;
    }
  };

  useEffect(() => {
    refreshCountdown();
    const countdownTimer = setInterval(() => {
      const status = refreshCountdown();
      if (status === -1) {
        clearInterval(countdownTimer);
        window.location.reload();
      }
    }, 200);
    return () => {
      clearInterval(countdownTimer);
    };
  }, []);

  return (
    <div
      className={CN_PRODUCT('flash-sale')}
      exptag={'exp|' + EXPOSURE_RECORD.Productdetail_SinglePromotionFloor_Expo}
      data-exptag-config={dataExpTagConfig}
      data-exptag-json-param={JSON.stringify({
        mainskuid: skuId,
        activityName: 'flash-sale',
        activityId: 'flash-sale',
      })}
    >
      <span className='flag'>{saleTag}</span>
      <div className={CN_PRODUCT('flash-sale-time')} suppressHydrationWarning={true}>
        {`${t('dp.flashSales.endsIn')}`} {(hour + '').padStart(2, '0')}:
        {(minute + '').padStart(2, '0')}:{(second + '').padStart(2, '0')}
      </div>
    </div>
  );
}
